export default __webpack_public_path__ + "static/media/note.ce308087.png";